(() => {
  document.documentElement.classList.add('bj3-motion-ready');
  window.setTimeout(() => document.documentElement.classList.remove('bj3-motion-ready'), 1600);

  const reveal = () => {
    const nodes = document.querySelectorAll('.bj3-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      document.documentElement.classList.remove('bj3-motion-ready');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach((node) => observer.observe(node));
  };

  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
